export const environment = {
  //BASE_URL: "http://68.178.165.130:8016",
  BASE_URL: "https://api.shivtrading.com.in/AdminAPI",
  BASE_URL2: "https://api.shivtrading.com.in/API",
  
}
